import React from 'react';
import { ContextProvider as ConfigurationProvider} from './context';
import { MockProvider } from '../enrollment/mock-provider';
import { enrollmentContextConst, EnrollmentContextProvider } from '../enrollment/enrollment-context';
import useConfiguration from '../../../../hooks/useConfiguration';
import { isStaticNavigation } from '../../../utilities/mock';
import useMockConfiguration from '../../../../hooks/useMockConfiguration';

const Provider: React.FC<{children: JSX.Element}> = ({ children }) => {

	const configuration = useConfiguration();
	const mockConfiguration = useMockConfiguration();
	const InputProvider = isStaticNavigation() 
		? MockProvider
		: EnrollmentContextProvider;
	if (mockConfiguration.isMockAllowed) {
		configuration.mock = mockConfiguration;
	}
	
	return (
		<ConfigurationProvider value={configuration}>
			<InputProvider value={enrollmentContextConst}>
				{children}
			</InputProvider>
		</ConfigurationProvider>
	);
};

export default Provider;
